import React from "react";
import { Tag } from "@bikdotai/bik-component-library";

interface ActiveFiltersDisplayProps {
  hasActiveFilters: boolean;
  activeFilters: Array<{
    type: string;
    label: string;
    onRemove: () => void;
  }>;
}

export const ActiveFiltersDisplay: React.FC<ActiveFiltersDisplayProps> = ({
  hasActiveFilters,
  activeFilters,
}) => {
  if (!hasActiveFilters) return null;

  const getFilterColor = (type: string) => {
    switch (type) {
      case "search":
        return { backgroundColor: "#e3f2fd", color: "#1976d2" };
      case "module":
        return { backgroundColor: "#f3e8ff", color: "#731DCF" };
      case "updateType":
        return { backgroundColor: "#fff3e0", color: "#f57c00" };
      case "date":
        return { backgroundColor: "#e8f5e8", color: "#2e7d32" };
      case "status":
        return { backgroundColor: "#fce4ec", color: "#c2185b" };
      default:
        return { backgroundColor: "#f5f5f5", color: "#666" };
    }
  };

  return (
    <div
      style={{
        display: "flex",
        gap: "8px",
        alignItems: "center",
        flexWrap: "wrap",
        paddingLeft: "12px",
      }}
    >
      <span style={{ fontSize: "12px", color: "#666" }}>Active filters:</span>
      {activeFilters.map((filter, index) => (
        <Tag
          key={index}
          tagText={filter.label}
          theme="light"
          type="white"
          TrailingIcon={() => (
            <span
              onClick={filter.onRemove}
              style={{
                cursor: "pointer",
                marginLeft: "4px",
                fontSize: "12px",
              }}
            >
              ×
            </span>
          )}
          onLeadingIconClicked={() => {}}
          onTrailingIconClicked={filter.onRemove}
          style={getFilterColor(filter.type)}
        />
      ))}
    </div>
  );
};
